
import BaseMixin from '@/views/mixin.vue'
import compSearch from './search';
import { HttpAllotShipList } from '@/service/allotment/transfer';

export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
    },
    data() {
        return {
        
        };
    },
    methods: {
        httpList: HttpAllotShipList,
    },
    computed: {
        columns() {
            return [{
                title: 'Seller SKU',
                key: 'sellerSku',
            }, {
                title: 'ERP SKU',
                key: 'erpSku',
            }, {
                title: '发运数量',
                key: 'shippingNum',
            }, {
                title: '接收数量',
                key: 'inboundAmount',
            }, {
                title: 'Disposition',
                key: 'disposition',
            }, {
                title: 'Carrier',
                key: 'carrier',
            }, {
                title: 'Tracking',
                key: 'tracking',
            }, {
                title: '状态',
                key: 'shippingType',
            },
            {
                title: '妥投时间',
                key: 'updatedAt',
            },
            {
                title: '预计到仓时间',
                key: 'updatedAt',
            },
            {
                title: '扫描时间',
                key: 'updatedAt',
            },
            {
                title: '物流状态',
                render(h, { row }) {
                    return <div>
                        {'out_for_delivery'}
                    </div>
                }
            }, {
                title: '发货时间',
                key: 'deliveryAt',
            }, {
                title: '更新时间',
                key: 'updatedAt',
            },
            ];
        },
    },
};




